/**
 * CoachPlaybook - Volleyball Sport Module
 * Version: 0.6.0
 * Description: Complete volleyball configuration — positions, actions, formations, rotations, age groups
 */

const volleyball = {
  id: 'volleyball',
  name: 'Volleyball',
  icon: '🏐',
  accentColor: '#06b6d4',
  surfaceType: 'court',

  // Court views available
  views: ['full', 'half-offense', 'half-defense'],
  defaultView: 'full',
  orientation: ['vertical', 'horizontal'],

  // Default player counts
  playersPerSide: 6,
  maxDefenders: 6,

  // Rotation system (6 rotations, positions 1-6)
  rotations: [
    {
      id: 'rotation-1',
      label: 'Rotation 1',
      positions: {
        1: { x: 75, y: 85, zone: 'back-right' },
        2: { x: 75, y: 35, zone: 'front-right' },
        3: { x: 50, y: 35, zone: 'front-middle' },
        4: { x: 25, y: 35, zone: 'front-left' },
        5: { x: 25, y: 85, zone: 'back-left' },
        6: { x: 50, y: 85, zone: 'back-middle' }
      }
    },
    {
      id: 'rotation-2',
      label: 'Rotation 2',
      positions: {
        1: { x: 75, y: 35, zone: 'front-right' },
        2: { x: 50, y: 35, zone: 'front-middle' },
        3: { x: 25, y: 35, zone: 'front-left' },
        4: { x: 25, y: 85, zone: 'back-left' },
        5: { x: 50, y: 85, zone: 'back-middle' },
        6: { x: 75, y: 85, zone: 'back-right' }
      }
    },
    {
      id: 'rotation-3',
      label: 'Rotation 3',
      positions: {
        1: { x: 50, y: 35, zone: 'front-middle' },
        2: { x: 25, y: 35, zone: 'front-left' },
        3: { x: 25, y: 85, zone: 'back-left' },
        4: { x: 50, y: 85, zone: 'back-middle' },
        5: { x: 75, y: 85, zone: 'back-right' },
        6: { x: 75, y: 35, zone: 'front-right' }
      }
    },
    {
      id: 'rotation-4',
      label: 'Rotation 4',
      positions: {
        1: { x: 25, y: 35, zone: 'front-left' },
        2: { x: 25, y: 85, zone: 'back-left' },
        3: { x: 50, y: 85, zone: 'back-middle' },
        4: { x: 75, y: 85, zone: 'back-right' },
        5: { x: 75, y: 35, zone: 'front-right' },
        6: { x: 50, y: 35, zone: 'front-middle' }
      }
    },
    {
      id: 'rotation-5',
      label: 'Rotation 5',
      positions: {
        1: { x: 25, y: 85, zone: 'back-left' },
        2: { x: 50, y: 85, zone: 'back-middle' },
        3: { x: 75, y: 85, zone: 'back-right' },
        4: { x: 75, y: 35, zone: 'front-right' },
        5: { x: 50, y: 35, zone: 'front-middle' },
        6: { x: 25, y: 35, zone: 'front-left' }
      }
    },
    {
      id: 'rotation-6',
      label: 'Rotation 6',
      positions: {
        1: { x: 50, y: 85, zone: 'back-middle' },
        2: { x: 75, y: 85, zone: 'back-right' },
        3: { x: 75, y: 35, zone: 'front-right' },
        4: { x: 50, y: 35, zone: 'front-middle' },
        5: { x: 25, y: 35, zone: 'front-left' },
        6: { x: 25, y: 85, zone: 'back-left' }
      }
    }
  ],

  // Age group configurations
  ageGroups: [
    { id: 'u10', label: 'U10', players: 6, courtSize: 'modified', netHeight: '1.83m', sets: 3, pointsPerSet: 25, modifiedRules: true },
    { id: 'u12', label: 'U12', players: 6, courtSize: 'modified', netHeight: '2.13m', sets: 3, pointsPerSet: 25, modifiedRules: true },
    { id: 'u14', label: 'U14', players: 6, courtSize: 'full', netHeight: '2.24m', sets: 3, pointsPerSet: 25, modifiedRules: false },
    { id: 'u16', label: 'U16', players: 6, courtSize: 'full', netHeight: '2.24m', sets: 3, pointsPerSet: 25, modifiedRules: false },
    { id: 'high', label: 'High School', players: 6, courtSize: 'full', netHeight: '2.24m', sets: 5, pointsPerSet: 25, modifiedRules: false },
    { id: 'college', label: 'College', players: 6, courtSize: 'full', netHeight: '2.24m', sets: 5, pointsPerSet: 25, modifiedRules: false },
    { id: 'pro', label: 'Pro', players: 6, courtSize: 'full', netHeight: '2.43m', sets: 5, pointsPerSet: 25, modifiedRules: false },
    { id: 'beach', label: 'Beach (2v2)', players: 2, courtSize: 'beach', netHeight: '2.43m', sets: 3, pointsPerSet: 21, modifiedRules: true }
  ],

  // Positions
  positions: [
    { id: 'S', name: 'Setter', short: 'S', number: null, defaultColor: '#facc15', role: 'offense' },
    { id: 'OH', name: 'Outside Hitter', short: 'OH', number: null, defaultColor: '#3b82f6', role: 'offense' },
    { id: 'MH', name: 'Middle Hitter/Blocker', short: 'MH/MB', number: null, defaultColor: '#ef4444', role: 'offense' },
    { id: 'OPP', name: 'Opposite/Right Side', short: 'OPP/RS', number: null, defaultColor: '#8b5cf6', role: 'offense' },
    { id: 'L', name: 'Libero', short: 'L', number: null, defaultColor: '#10b981', role: 'defense' },
    { id: 'DS', name: 'Defensive Specialist', short: 'DS', number: null, defaultColor: '#f97316', role: 'defense' }
  ],

  // Default formation (5-1 base, rotation 1)
  defaultFormation: {
    name: '5-1 Base',
    positions: {
      S:   { x: 75, y: 35, hasBall: false },
      OH:  { x: 25, y: 35, hasBall: false },
      MH:  { x: 50, y: 35, hasBall: false },
      OPP: { x: 75, y: 85, hasBall: false },
      L:   { x: 50, y: 85, hasBall: false },
      DS:  { x: 25, y: 85, hasBall: false }
    }
  },

  // Common formations
  formations: [
    // Offensive systems
    {
      id: '5-1',
      name: '5-1 Offense',
      type: 'offense',
      description: 'One setter, five hitters — setter sets from all rotations',
      positions: { S: { x: 75, y: 35 }, OH: { x: 25, y: 35 }, MH: { x: 50, y: 35 }, OPP: { x: 75, y: 85 }, L: { x: 50, y: 85 }, DS: { x: 25, y: 85 } }
    },
    {
      id: '6-2',
      name: '6-2 Offense',
      type: 'offense',
      description: 'Two setters — back-row setter always sets, six attackers available',
      positions: { S: { x: 75, y: 85 }, OH: { x: 25, y: 35 }, MH: { x: 50, y: 35 }, OPP: { x: 75, y: 35 }, L: { x: 50, y: 85 }, DS: { x: 25, y: 85 } }
    },
    {
      id: '4-2',
      name: '4-2 Offense',
      type: 'offense',
      description: 'Two setters — front-row setter sets, four hitters attack',
      positions: { S: { x: 75, y: 35 }, OH: { x: 25, y: 35 }, MH: { x: 50, y: 35 }, OPP: { x: 75, y: 85 }, L: { x: 50, y: 85 }, DS: { x: 25, y: 85 } }
    },
    {
      id: 'international-4-2',
      name: 'International 4-2',
      type: 'offense',
      description: 'Front-row setter slides to middle, giving three-hitter look',
      positions: { S: { x: 50, y: 30 }, OH: { x: 25, y: 35 }, MH: { x: 15, y: 35 }, OPP: { x: 75, y: 85 }, L: { x: 50, y: 85 }, DS: { x: 25, y: 85 } }
    },
    // Defensive systems
    {
      id: 'perimeter',
      name: 'Perimeter Defense',
      type: 'defense',
      description: 'Back-row players positioned near sidelines and endline',
      positions: { S: { x: 75, y: 35 }, OH: { x: 25, y: 35 }, MH: { x: 50, y: 35 }, OPP: { x: 80, y: 90 }, L: { x: 50, y: 95 }, DS: { x: 20, y: 90 } }
    },
    {
      id: 'rotational',
      name: 'Rotational Defense',
      type: 'defense',
      description: 'Back-row rotates based on hitter location — strong-side defender moves up',
      positions: { S: { x: 75, y: 35 }, OH: { x: 25, y: 35 }, MH: { x: 50, y: 35 }, OPP: { x: 70, y: 60 }, L: { x: 50, y: 85 }, DS: { x: 20, y: 90 } }
    },
    {
      id: 'man-up',
      name: 'Man-Up Defense',
      type: 'defense',
      description: 'Middle-back player moves up behind block for tips and roll shots',
      positions: { S: { x: 75, y: 35 }, OH: { x: 25, y: 35 }, MH: { x: 50, y: 35 }, OPP: { x: 80, y: 90 }, L: { x: 50, y: 60 }, DS: { x: 20, y: 90 } }
    },
    {
      id: 'read',
      name: 'Read Defense',
      type: 'defense',
      description: 'Defenders read the hitter and react — most common at advanced levels',
      positions: { S: { x: 75, y: 35 }, OH: { x: 25, y: 35 }, MH: { x: 50, y: 35 }, OPP: { x: 75, y: 80 }, L: { x: 50, y: 80 }, DS: { x: 25, y: 80 } }
    },
    // Serve receive formations
    {
      id: 'w-formation',
      name: 'W Formation (Serve Receive)',
      type: 'serve-receive',
      description: 'Five-player W-shaped serve receive pattern',
      positions: { S: { x: 75, y: 35 }, OH: { x: 30, y: 60 }, MH: { x: 50, y: 45 }, OPP: { x: 70, y: 60 }, L: { x: 40, y: 80 }, DS: { x: 60, y: 80 } }
    },
    {
      id: '3-person-receive',
      name: '3-Person Serve Receive',
      type: 'serve-receive',
      description: 'Three passers handle serve receive — common at higher levels',
      positions: { S: { x: 75, y: 35 }, OH: { x: 25, y: 70 }, MH: { x: 50, y: 35 }, OPP: { x: 75, y: 70 }, L: { x: 50, y: 80 }, DS: { x: 25, y: 35 } }
    },
    {
      id: '2-person-receive',
      name: '2-Person Serve Receive',
      type: 'serve-receive',
      description: 'Two best passers handle all serves — elite level pattern',
      positions: { S: { x: 75, y: 35 }, OH: { x: 35, y: 75 }, MH: { x: 50, y: 35 }, OPP: { x: 75, y: 85 }, L: { x: 65, y: 75 }, DS: { x: 25, y: 35 } }
    },
    {
      id: 'stack-receive',
      name: 'Stack Serve Receive',
      type: 'serve-receive',
      description: 'Players stack behind each other to create movement after serve',
      positions: { S: { x: 75, y: 35 }, OH: { x: 30, y: 50 }, MH: { x: 30, y: 35 }, OPP: { x: 70, y: 50 }, L: { x: 50, y: 75 }, DS: { x: 50, y: 85 } }
    },
    // 5-1 Rotation-specific formations
    {
      id: '5-1-rotation-1',
      name: '5-1 Rotation 1',
      type: 'offense',
      description: 'Setter front-right (zone 2), OH front-left, MH front-middle',
      positions: { S: { x: 75, y: 35 }, OH: { x: 25, y: 35 }, MH: { x: 50, y: 35 }, OPP: { x: 75, y: 85 }, L: { x: 50, y: 85 }, DS: { x: 25, y: 85 } }
    },
    {
      id: '5-1-rotation-2',
      name: '5-1 Rotation 2',
      type: 'offense',
      description: 'Setter front-middle (zone 3), penetrates to right',
      positions: { S: { x: 50, y: 35 }, OH: { x: 75, y: 35 }, MH: { x: 25, y: 35 }, OPP: { x: 25, y: 85 }, L: { x: 75, y: 85 }, DS: { x: 50, y: 85 } }
    },
    {
      id: '5-1-rotation-3',
      name: '5-1 Rotation 3',
      type: 'offense',
      description: 'Setter front-left (zone 4), penetrates to right',
      positions: { S: { x: 25, y: 35 }, OH: { x: 50, y: 35 }, MH: { x: 75, y: 35 }, OPP: { x: 50, y: 85 }, L: { x: 25, y: 85 }, DS: { x: 75, y: 85 } }
    },
    {
      id: '5-1-rotation-4',
      name: '5-1 Rotation 4',
      type: 'offense',
      description: 'Setter back-right (zone 1), penetrates to net',
      positions: { S: { x: 75, y: 85 }, OH: { x: 25, y: 35 }, MH: { x: 50, y: 35 }, OPP: { x: 75, y: 35 }, L: { x: 50, y: 85 }, DS: { x: 25, y: 85 } }
    },
    {
      id: '5-1-rotation-5',
      name: '5-1 Rotation 5',
      type: 'offense',
      description: 'Setter back-middle (zone 6), penetrates to right',
      positions: { S: { x: 50, y: 85 }, OH: { x: 75, y: 35 }, MH: { x: 25, y: 35 }, OPP: { x: 25, y: 45 }, L: { x: 75, y: 85 }, DS: { x: 25, y: 85 } }
    },
    {
      id: '5-1-rotation-6',
      name: '5-1 Rotation 6',
      type: 'offense',
      description: 'Setter back-left (zone 5), penetrates to right',
      positions: { S: { x: 25, y: 85 }, OH: { x: 50, y: 35 }, MH: { x: 75, y: 35 }, OPP: { x: 25, y: 35 }, L: { x: 50, y: 85 }, DS: { x: 75, y: 85 } }
    }
  ],

  // Complete action library
  actions: {
    offense: [
      // Serving
      { id: 'float-serve', name: 'Float Serve', icon: '🏐', lineStyle: 'arrow', category: 'serve' },
      { id: 'jump-float', name: 'Jump Float Serve', icon: '🏐⬆️', lineStyle: 'arrow', category: 'serve' },
      { id: 'jump-topspin', name: 'Jump Topspin Serve', icon: '🌀', lineStyle: 'arrow', category: 'serve' },
      { id: 'underhand-serve', name: 'Underhand Serve', icon: '🤲', lineStyle: 'arrow', category: 'serve' },
      // Passing
      { id: 'pass', name: 'Pass/Bump', icon: '🤜', lineStyle: 'arrow', category: 'passing' },
      { id: 'free-ball-send', name: 'Free Ball Send', icon: '📤', lineStyle: 'arrow', category: 'passing' },
      // Setting
      { id: 'front-set', name: 'Front Set', icon: '🙌', lineStyle: 'arrow-lob', category: 'setting' },
      { id: 'back-set', name: 'Back Set', icon: '🔙', lineStyle: 'arrow-lob', category: 'setting' },
      { id: 'dump', name: 'Dump', icon: '💥', lineStyle: 'arrow', category: 'setting' },
      { id: 'jump-set', name: 'Jump Set', icon: '⬆️', lineStyle: 'arrow-lob', category: 'setting' },
      { id: 'shoot-set', name: 'Shoot Set', icon: '➡️', lineStyle: 'arrow', category: 'setting' },
      { id: 'one-tempo', name: 'One Tempo (Quick)', icon: '1️⃣', lineStyle: 'arrow', category: 'setting' },
      { id: 'two-tempo', name: 'Two Tempo', icon: '2️⃣', lineStyle: 'arrow-lob', category: 'setting' },
      { id: 'three-tempo', name: 'Three Tempo', icon: '3️⃣', lineStyle: 'arrow-lob', category: 'setting' },
      { id: 'four-tempo', name: 'Four Tempo (High)', icon: '4️⃣', lineStyle: 'arrow-lob', category: 'setting' },
      { id: 'five-tempo', name: 'Five Tempo (High Outside)', icon: '5️⃣', lineStyle: 'arrow-lob', category: 'setting' },
      // Hitting / Spiking
      { id: 'cross-body', name: 'Cross-Body Hit', icon: '↗️', lineStyle: 'arrow', category: 'hitting' },
      { id: 'line-hit', name: 'Line Hit', icon: '⬇️', lineStyle: 'arrow', category: 'hitting' },
      { id: 'cut-shot', name: 'Cut Shot', icon: '✂️', lineStyle: 'arrow', category: 'hitting' },
      { id: 'roll-shot', name: 'Roll Shot', icon: '🌊', lineStyle: 'arrow-lob', category: 'hitting' },
      { id: 'tip', name: 'Tip', icon: '👆', lineStyle: 'arrow-lob', category: 'hitting' },
      { id: 'wipe', name: 'Wipe/Tool', icon: '🖐️', lineStyle: 'arrow', category: 'hitting' },
      { id: 'back-row-attack', name: 'Back Row Attack', icon: '🚀', lineStyle: 'arrow', category: 'hitting' },
      { id: 'pipe', name: 'Pipe', icon: '🔥', lineStyle: 'arrow', category: 'hitting' },
      { id: 'slide', name: 'Slide', icon: '➡️💨', lineStyle: 'arrow', category: 'hitting' },
      { id: 'quick-attack', name: 'Quick Attack', icon: '⚡', lineStyle: 'arrow', category: 'hitting' },
      // Movement
      { id: 'approach', name: 'Approach', icon: '🏃', lineStyle: 'dashed', category: 'movement' },
      { id: 'move', name: 'Move', icon: '💨', lineStyle: 'dashed', category: 'movement' },
      { id: 'swap', name: 'Position Swap', icon: '🔀', lineStyle: 'dashed', category: 'movement' }
    ],
    defense: [
      // Blocking
      { id: 'solo-block', name: 'Solo Block', icon: '🖐️', lineStyle: 'solid', category: 'blocking' },
      { id: 'double-block', name: 'Double Block', icon: '🤚🤚', lineStyle: 'solid', category: 'blocking' },
      { id: 'triple-block', name: 'Triple Block', icon: '🧱', lineStyle: 'solid', category: 'blocking' },
      { id: 'joust', name: 'Joust', icon: '⚔️', lineStyle: 'solid', category: 'blocking' },
      { id: 'swing-block', name: 'Swing Block', icon: '🔄', lineStyle: 'solid', category: 'blocking' },
      { id: 'seal-block', name: 'Seal Block', icon: '🛡️', lineStyle: 'solid', category: 'blocking' },
      { id: 'tool-block', name: 'Tool the Block', icon: '🔧', lineStyle: 'solid', category: 'blocking' },
      { id: 'read-block', name: 'Read Block', icon: '👁️', lineStyle: 'solid', category: 'blocking' },
      { id: 'commit-block', name: 'Commit Block', icon: '🎯', lineStyle: 'solid', category: 'blocking' },
      { id: 'peel-off', name: 'Peel Off', icon: '↩️', lineStyle: 'dashed', category: 'blocking' },
      // Digging
      { id: 'dig', name: 'Dig', icon: '🤜', lineStyle: 'arrow', category: 'digging' },
      { id: 'sprawl', name: 'Sprawl', icon: '🦎', lineStyle: 'none', category: 'digging' },
      { id: 'pancake', name: 'Pancake', icon: '🥞', lineStyle: 'none', category: 'digging' },
      { id: 'roll-dig', name: 'Roll', icon: '🔄', lineStyle: 'none', category: 'digging' },
      { id: 'platform-dig', name: 'Platform Dig', icon: '🤲', lineStyle: 'arrow', category: 'digging' },
      { id: 'overhand-dig', name: 'Overhand Dig', icon: '🙌', lineStyle: 'arrow', category: 'digging' },
      // Coverage & Transition
      { id: 'hitter-coverage', name: 'Hitter Coverage', icon: '🛡️', lineStyle: 'dashed', category: 'coverage' },
      { id: 'transition', name: 'Transition', icon: '🔄', lineStyle: 'dashed', category: 'coverage' },
      { id: 'defensive-move', name: 'Defensive Move', icon: '💨', lineStyle: 'dashed', category: 'coverage' },
      { id: 'rotate-defense', name: 'Defensive Rotation', icon: '🔁', lineStyle: 'dashed', category: 'coverage' }
    ],
    serveReceive: [
      { id: 'receive', name: 'Serve Receive', icon: '🤜', lineStyle: 'arrow', category: 'receive' },
      { id: 'overhand-receive', name: 'Overhand Receive', icon: '🙌', lineStyle: 'arrow', category: 'receive' },
      { id: 'shift-left', name: 'Shift Left', icon: '⬅️', lineStyle: 'dashed', category: 'receive' },
      { id: 'shift-right', name: 'Shift Right', icon: '➡️', lineStyle: 'dashed', category: 'receive' },
      { id: 'seam-responsibility', name: 'Seam Call', icon: '📢', lineStyle: 'none', category: 'receive' }
    ],
    coverage: [
      { id: 'cover-position', name: 'Coverage Position', icon: '🛡️', lineStyle: 'dashed', category: 'coverage' },
      { id: 'close-cover', name: 'Close Coverage', icon: '🔵', lineStyle: 'dashed', category: 'coverage' },
      { id: 'deep-cover', name: 'Deep Coverage', icon: '🔴', lineStyle: 'dashed', category: 'coverage' }
    ]
  },

  // Play categories
  playTypes: {
    offense: [
      { id: 'quick-attack', label: 'Quick Attack' },
      { id: 'combination', label: 'Combination Play' },
      { id: 'slide-play', label: 'Slide Play' },
      { id: 'pipe-play', label: 'Pipe Play' },
      { id: 'back-row', label: 'Back Row Attack' },
      { id: 'dump-play', label: 'Setter Dump' },
      { id: 'free-ball', label: 'Free Ball Offense' },
      { id: 'transition-offense', label: 'Transition Offense' },
      { id: 'out-of-system', label: 'Out of System' },
      { id: 'go-play', label: 'Go / Tempo Play' },
      { id: 'x-play', label: 'X / Cross Play' },
      { id: 'tandem', label: 'Tandem' },
      { id: 'stack-play', label: 'Stack Play' }
    ],
    defense: [
      { id: 'perimeter-defense', label: 'Perimeter Defense' },
      { id: 'rotational-defense', label: 'Rotational Defense' },
      { id: 'man-up-defense', label: 'Man-Up Defense' },
      { id: 'read-defense', label: 'Read Defense' },
      { id: 'blocking-scheme', label: 'Blocking Scheme' },
      { id: 'defensive-rotation', label: 'Defensive Rotation' },
      { id: 'tip-coverage', label: 'Tip Coverage' },
      { id: 'line-defense', label: 'Line Defense' },
      { id: 'cross-defense', label: 'Cross-Court Defense' }
    ],
    serve: [
      { id: 'serve-zone', label: 'Serve to Zone' },
      { id: 'serve-short', label: 'Short Serve' },
      { id: 'serve-deep', label: 'Deep Serve' },
      { id: 'serve-seam', label: 'Serve to Seam' },
      { id: 'serve-float-strategy', label: 'Float Serve Strategy' },
      { id: 'serve-aggressive', label: 'Aggressive Serve' },
      { id: 'serve-tactical', label: 'Tactical Serve' }
    ],
    special: [
      { id: 'serve-receive-play', label: 'Serve Receive Play' },
      { id: 'coverage-formation', label: 'Coverage Formation' },
      { id: 'rotation-overlap', label: 'Rotation / Overlap' },
      { id: 'substitution', label: 'Substitution Pattern' },
      { id: 'libero-replacement', label: 'Libero Replacement' },
      { id: 'timeout-play', label: 'After Timeout Play' }
    ]
  },

  // Stat categories for this sport
  statCategories: [
    { id: 'kills', name: 'Kills', short: 'K', type: 'counting' },
    { id: 'errors', name: 'Hitting Errors', short: 'E', type: 'counting' },
    { id: 'attempts', name: 'Attempts', short: 'TA', type: 'counting' },
    { id: 'hitting-pct', name: 'Hitting %', short: 'HIT%', type: 'calculated' },
    { id: 'assists', name: 'Assists', short: 'A', type: 'counting' },
    { id: 'aces', name: 'Aces', short: 'SA', type: 'counting' },
    { id: 'service-errors', name: 'Service Errors', short: 'SE', type: 'counting' },
    { id: 'digs', name: 'Digs', short: 'D', type: 'counting' },
    { id: 'solo-blocks', name: 'Solo Blocks', short: 'BS', type: 'counting' },
    { id: 'block-assists', name: 'Block Assists', short: 'BA', type: 'counting' },
    { id: 'block-errors', name: 'Block Errors', short: 'BE', type: 'counting' },
    { id: 'receptions', name: 'Receptions', short: 'R', type: 'counting' },
    { id: 'reception-errors', name: 'Reception Errors', short: 'RE', type: 'counting' },
    { id: 'passing-rating', name: 'Passing Rating', short: 'PASS', type: 'calculated' },
    { id: 'ball-handling-errors', name: 'Ball Handling Errors', short: 'BHE', type: 'counting' },
    { id: 'points', name: 'Points', short: 'PTS', type: 'counting' },
    { id: 'sets-played', name: 'Sets Played', short: 'SP', type: 'counting' }
  ],

  // Scouting skill categories
  scoutingSkills: [
    { id: 'hitting-power', name: 'Hitting Power', icon: '💥' },
    { id: 'ball-control', name: 'Ball Control', icon: '🏐' },
    { id: 'court-vision', name: 'Court Vision', icon: '👁️' },
    { id: 'blocking', name: 'Blocking', icon: '🖐️' },
    { id: 'serving', name: 'Serving', icon: '🎯' },
    { id: 'passing', name: 'Passing', icon: '🤜' },
    { id: 'setting', name: 'Setting', icon: '🙌' },
    { id: 'defense', name: 'Defense', icon: '🛡️' }
  ],

  // Court dimensions (for SVG rendering)
  court: {
    // FIVB standard dimensions in meters
    width: 9,       // 29.5 ft
    length: 18,      // 59 ft
    halfLength: 9,
    netHeight: {
      men: 2.43,     // meters
      women: 2.24    // meters
    },
    attackLine: 3,   // 3m from center line (10 ft)
    serviceZone: 9,  // full width behind endline
    freeZone: 3,     // minimum free zone around court
    antennaHeight: 0.8, // extends 80cm above net
    // Court markings
    markings: [
      'center-line', 'attack-line', 'endline', 'sideline',
      'net', 'antenna', 'service-zone', 'substitution-zone',
      'libero-replacement-zone', 'warm-up-area', 'zones-1-6'
    ]
  }
};

export default volleyball;
